import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { fetchTrackEvent } from 'src/redux/productAnalytics'
import { mapEmailEvent } from './helpers'

const ViewPort = ({ children }) => {
  let ref = React.useRef(null)
  const { email } = useSelector(state => state.identity)
  const dispatch = useDispatch()
  const route = window.location.pathname
  const searchParams = new URLSearchParams(window.location.search)

  useEffect(() => {
    const emailEvent = mapEmailEvent({ searchParams, email })
    if (emailEvent) {
      dispatch(fetchTrackEvent(emailEvent))
    }
  }, [route, email, dispatch])

  return (
    <>
      <div ref={ref} />
      <div id='backdrop'>
        <div id='viewport'>{children}</div>
      </div>
    </>
  )
}

export default ViewPort
